var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 642,
    height: 887,
    viewBox: "0 0 642 887",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M642 307.5C642 627.549 382.549 887 62.5 887C-257.549 887 -517 627.549 -517 307.5C-517 -12.549 -257.549 -272 62.5 -272C382.549 -272 642 -12.549 642 307.5Z",
    fill: "#F4F9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M359 133.5C359 332.046 198.046 493 -0.5 493C-199.046 493 -360 332.046 -360 133.5C-360 -65.0464 -199.046 -226 -0.5 -226C198.046 -226 359 -65.0464 359 133.5Z",
    fill: "#E7F1FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBg);
export default __webpack_public_path__ + "static/media/homeBg.a5541bd76bce2a6ab3d2f29888d3c933.svg";
export { ForwardRef as ReactComponent };